import { configureStore } from "@reduxjs/toolkit";
import clientReducer from "./Slices/SelectedClientSlice";
import careersClientReducer from "./Slices/SelectedCareersClientSlice";
import userPermissionsReducer from "./Slices/UserPermissionsSlice";
import userInformationReducer from "./Slices/UserInformationSlice";
import allClientsReducer from "./Slices/AllClientsSlice";
import reportDateReducer from "./Slices/ReportDateSlice";
import noficationReducer from "./Slices/NotificationSlice";
import modalReducer from "./Slices/ModalSlice";
import tabGroupReducer from "./Slices/TabGroupSlice";
import abacUserReducer from "./Slices/AbacUserSlice";
import adminStateReducer from "./Slices/AdminSlice";
import dashboardStateReducer from "./Slices/DashboardSettingsSlice";
import storage from "redux-persist/lib/storage";
import { persistStore, persistReducer } from "redux-persist";
import thunk from "redux-thunk";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

const userPermissionsPersistConfig = {
  key: "userPermissions",
  storage,
};

const clientPersistConfig = {
  key: "client",
  storage,
};

const careersClientPersistConfig = {
  key: "careersClient",
  storage,
};

const abacUserPersistConfig = {
  key: "abacUser",
  storage,
};

const adminStatePersistConfig = {
  key: "adminState",
  storage,
};

const dashboardStatePersistConfig = {
  key: "dashboardSettings",
  storage,
};

const persistedUserPermissionsReducer = persistReducer(
  userPermissionsPersistConfig,
  userPermissionsReducer
);
const persistedClientReducer = persistReducer(
  clientPersistConfig,
  clientReducer
);
const persistedCareersClientReducer = persistReducer(
  careersClientPersistConfig,
  careersClientReducer
);
const persistedAbacUserReducer = persistReducer(
  abacUserPersistConfig,
  abacUserReducer
);
const persistedAdminStateReducer = persistReducer(
  adminStatePersistConfig,
  adminStateReducer
);

const persistedDashboardStateReducer = persistReducer(
  dashboardStatePersistConfig,
  dashboardStateReducer
);

export const store = configureStore({
  reducer: {
    selectedClient: persistedClientReducer,
    selectedCareersClient: persistedCareersClientReducer,
    userPermissions: persistedUserPermissionsReducer,
    userInformation: userInformationReducer,
    allClients: allClientsReducer,
    reportDate: reportDateReducer,
    notification: noficationReducer,
    modal: modalReducer,
    tabGroup: tabGroupReducer,
    abacUser: persistedAbacUserReducer,
    adminState: persistedAdminStateReducer,
    dashboardSettings: persistedDashboardStateReducer,
  },
  middleware: [thunk],
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

type DispatchFunc = () => AppDispatch;
export const useAppDispatch: DispatchFunc = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export type TypedSelectFn = <T>(state: RootState) => T;
